module.exports = __webpack_public_path__ + "static/Caviar-cb63f7873891571fbed998cd9175cac8.jpg";